import React from 'react'
import { Icon } from 'antd'

const AUDIO_MODES = [
  {
    key: 'narration',
    value: 'narration',
    icon: 'audio',
    title: 'Narration',
    description:
      'Single narrator voice reads the entire story. Best for documentaries, explainers, and educational content.',
    color: '#722ed1'
  },
  {
    key: 'dialogue',
    value: 'dialogue',
    icon: 'team',
    title: 'Dialogue',
    description:
      'Multiple character voices with distinct dialogue. Best for stories with conversations and character interactions.',
    color: '#eb2f96'
  },
  {
    key: 'dialogue_and_narration',
    value: 'dialogue_and_narration',
    icon: 'sound',
    title: 'Dialogue and Narration',
    description:
      'Mix of narration and dialogue. Best for stories with both narration and character interactions.',
    color: '#52c41a'
  }
]

const AudioModeSelector = ({ selectedMode, onSelectMode, disabled = false }) => {
  return (
    <div className="audio-mode-selector">
      <div className="audio-mode-selector__header">
        <Icon type="sound" className="audio-mode-selector__header-icon" />
        <div>
          <h4 className="audio-mode-selector__title">Story Audio Mode</h4>
          <p className="audio-mode-selector__subtitle">
            How should the audio be generated for your story?
          </p>
        </div>
      </div>

      <div className="audio-mode-selector__options">
        {AUDIO_MODES.map(mode => {
          const isSelected = selectedMode === mode.value
          return (
            <div
              key={mode.key}
              className={`audio-mode-option ${
                isSelected ? 'audio-mode-option--selected' : ''
              } ${disabled ? 'audio-mode-option--disabled' : ''}`}
              onClick={disabled ? undefined : () => onSelectMode(mode.value)}
              aria-disabled={disabled}
              style={{
                '--option-color': mode.color,
                '--option-color-light': `${mode.color}12`,
                '--option-color-border': isSelected ? mode.color : 'transparent'
              }}
            >
              <div className="audio-mode-option__icon">
                <Icon type={mode.icon} />
              </div>
              <div className="audio-mode-option__content">
                <span className="audio-mode-option__title">{mode.title}</span>
                <span className="audio-mode-option__description">
                  {mode.description}
                </span>
              </div>
              <div className="audio-mode-option__check">
                {isSelected && <Icon type="check-circle" theme="filled" />}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AudioModeSelector
